@if (!FikoYT.kimlik.aktifKullaniciJson()) {

<!-- Üye olmayan kullanıcı ana sayfası -->
<div class="hosgeldin-alan">
   <div class="hosgeldin-kart">
      <div class="hosgeldin-logo">
         <img src="./simgeler/logo.png" height="80" />
      </div>

      <h2 class="hosgeldin-baslik">FikoYT Sistem</h2>
      <p class="hosgeldin-aciklama">
         Tüm FikoYT uygulamalarına tek çatı altından erişin.
         Giriş yaparak size özel uygulamalara ulaşabilirsiniz.
      </p>

      <div class="hosgeldin-butonlar">
         <button class="ui blue fluid large button giris-btn"
                 [routerLink]="['/giris']">
            <i class="sign in alternate icon"></i>
            Giriş Yap
         </button>
         <button class="ui basic fluid button kayit-btn"
                 [routerLink]="['/kayit']">
            <i class="user plus icon"></i>
            Aramıza Katıl
         </button>
      </div>

      <!-- Ayırıcı -->
      <div class="hosgeldin-ayirici">
         <span>Keşfet</span>
      </div>

      <!-- Uygulama önizleme kartları -->
      <div class="onizleme-grid">
         @for (uygulama of uygulamalar; track uygulama.baslik) {
         <div class="onizleme-kart"
              [class.yukleniyor]="yuklenenKart() === uygulama.baslik"
              [style.--kart-renk]="uygulama.renk"
              [style.border-color]="yuklenenKart() === uygulama.baslik ? uygulama.renk : uygulama.renk + '30'"
              (click)="kartTikla(uygulama)"
              style="cursor: pointer;">
            <div class="onizleme-simge"
                 [style.background]="uygulama.arkaplanGradient">
               @if (uygulama.simgeTuru === 'img' && uygulama.simgeResim) {
               <img [alt]="uygulama.baslik"
                    [src]="uygulama.simgeResim"
                    style="height: 2rem; border-radius: 4px; filter: drop-shadow(0 1px 2px rgba(0,0,0,0.2));" />
               } @else {
               <span style="font-size: 1.8rem;">{{ uygulama.simge }}</span>
               }
            </div>
            <div class="onizleme-icerik">
               <div class="onizleme-baslik">{{ uygulama.baslik }}</div>
               <div class="onizleme-aciklama">{{ uygulama.aciklama }}</div>
            </div>
            <!-- Progress overlay - tum karti kaplar -->
            @if (yuklenenKart() === uygulama.baslik) {
            <div class="onizleme-kart-overlay" [style.--kart-gradient]="uygulama.arkaplanGradient">
               <div class="onizleme-kart-overlay-ust">
                  @if (uygulama.simgeTuru === 'img' && uygulama.simgeResim) {
                  <img [src]="uygulama.simgeResim" style="height:1.6rem; filter: brightness(10);" />
                  } @else {
                  <span style="font-size:1.4rem;">{{ uygulama.simge }}</span>
                  }
                  <span class="onizleme-kart-overlay-baslik">{{ uygulama.baslik }}</span>
               </div>
               <div class="onizleme-kart-overlay-progress">
                  <div class="kart-progress-bar" style="background:rgba(255,255,255,0.15)">
                     <div class="kart-progress-dolgu" [style.width.%]="yuklenmeYuzdesi()"></div>
                  </div>
                  <div class="onizleme-kart-overlay-bilgi">
                     <span>{{ yuklenmeAdimi() }}</span>
                     @if (indirilenBoyut()) {
                     <span class="kart-progress-boyut">{{ indirilenBoyut() }}</span>
                     }
                  </div>
               </div>
            </div>
            }
            @if (uygulama.yetkiAdi) {
            <div class="onizleme-kilit">
               <i class="lock icon" style="color: #9ca3af; font-size: 0.8rem;"></i>
            </div>
            }
         </div>
         }
      </div>

   </div>
</div>

} @else {

<!-- Üye olan kullanıcı ana sayfası -->
<div class="uye-hero">
   <div class="uye-hero-bg"></div>
   <div class="uye-hero-icerik">
      <div class="uye-avatar-alani">
         <div class="uye-avatar-halka">
            <img class="uye-avatar-img"
                 width="62" height="62"
                 [src]="FikoYT.env.adres.fapiUrl+'/fikoyt.com.FikoYT.sistem.aktif-kullanici.profilResmi?boyut=128x?&t='+FikoYT.parametreler['t']+'&quality=40'"
                 alt="avatar"
                 (error)="$any($event.target).style.display='none'; $any($event.target).nextElementSibling.style.display='flex'" />
            <span class="uye-avatar-fb" style="display:none">
               {{ (FikoYT.kimlik.aktifKullaniciJson()?.isim?.[0] || FikoYT.kimlik.aktifKullaniciJson()?.kullaniciAdi?.[0] || '?') | uppercase }}
            </span>
         </div>
         <div class="uye-durum-nokta"></div>
      </div>
      <div class="uye-bilgi">
         <span class="uye-selamlama">Hoş geldin</span>
         <h2 class="uye-isim">
            @if (FikoYT.kimlik.aktifKullaniciJson()?.isim) {
               {{ FikoYT.kimlik.aktifKullaniciJson()?.isim }} {{ FikoYT.kimlik.aktifKullaniciJson()?.soyIsim }}
            } @else {
               {{ FikoYT.kimlik.aktifKullaniciJson()?.kullaniciAdi || 'Kullanıcı' }}
            }
         </h2>
         <span class="uye-email">{{ FikoYT.kimlik.aktifKullaniciJson()?.ePosta }}</span>
      </div>
   </div>
</div>

<!-- Başlık -->
<div class="uyg-baslik-alan">
   <div class="uyg-baslik-cizgi"></div>
   <div class="uyg-baslik-etiket">
      <span class="uyg-baslik-simge">⚡</span>
      <span class="uyg-baslik-yazi">Uygulamalarım</span>
      <span class="uyg-baslik-sayi">{{ erisilebilenUygulamalar.length }}</span>
   </div>
   <div class="uyg-baslik-cizgi"></div>
</div>

<!-- Uygulama kartları -->
<div class="uygulama-grid">

   @for (uygulama of erisilebilenUygulamalar; track uygulama.baslik) {
   <div class="uygulama-kart hoverable hover:zipla-5 active:zipla-5"
        [class.yukleniyor]="yuklenenKart() === uygulama.baslik"
        (click)="kartTikla(uygulama)"
        [style.--kart-renk]="uygulama.renk">
      <div class="uygulama-kart-ust"
           [style.background]="uygulama.arkaplanGradient">
         @if (uygulama.simgeTuru === 'img' && uygulama.simgeResim) {
         <img [alt]="uygulama.baslik"
              [src]="uygulama.simgeResim"
              class="uygulama-kart-simge-img" />
         } @else {
         <span class="uygulama-kart-simge-emoji">{{ uygulama.simge }}</span>
         }

         <!-- Progress overlay - simge alaninin icinde -->
         @if (yuklenenKart() === uygulama.baslik) {
         <div class="kart-progress-overlay">
            <div class="kart-progress-bar">
               <div class="kart-progress-dolgu" [style.width.%]="yuklenmeYuzdesi()"></div>
            </div>
            <div class="kart-progress-bilgi">
               <span class="kart-progress-adim">{{ yuklenmeAdimi() }}</span>
               @if (indirilenBoyut()) {
                  <span class="kart-progress-boyut">{{ indirilenBoyut() }}</span>
               }
            </div>
         </div>
         }
      </div>
      <div class="uygulama-kart-alt">
         <div class="uygulama-kart-baslik">{{ uygulama.baslik }}</div>
         <div class="uygulama-kart-aciklama">{{ uygulama.aciklama }}</div>
      </div>
   </div>
   }

</div>

}
